window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

repos.casinoSuperbombaJeAktivnaRepo = function () {
    var url = 'api/casinosuperbombajeaktivna';

    var get = function () {
        return fetch(url, { credentials: repos.base.credentials })
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);
    };

    return {
        get: get
    }
}();